export enum StringFormat {
    SnakeCase = 'snakeCase',
    SentenceCase = 'sentenceCase',
    TitleCase = 'titleCase',
}

type FromStringFormat = StringFormat.SnakeCase;
type ToStringFormat = StringFormat.SentenceCase | StringFormat.TitleCase;

export const toSentenceCase = (v: string): string => {
    const firstLetter = v.charAt(0).toUpperCase();
    const rest = v.slice(1);
    return `${firstLetter}${rest}`.split('_').join(' ');
};

export const formatString = (
    str: string,
    fromFormat: FromStringFormat,
    toFormat: ToStringFormat,
    fallback = '',
): string => {
    if (!str) {
        return fallback;
    }

    switch (fromFormat) {
        case StringFormat.SnakeCase:
            switch (toFormat) {
                case StringFormat.SentenceCase: {
                    return toSentenceCase(str);
                }
                case StringFormat.TitleCase: {
                    return str.split('_').map((word) => {
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                }
                default:
                    return str;
            }
        default:
            return str;
    }
};
